import { Box, Button, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { Link as RouterLink } from "react-router"

function NotFound() {
  const { t } = useTranslation()
  return (
    <Stack
      sx={{
        alignItems: "center",
        p: 5,
      }}
    >
      <Stack
        sx={{
          alignItems: "center",
          maxWidth: "600px",
        }}
      >
        <Box>
          <Typography
            variant="h3"
            paragraph
            sx={{
              textAlign: "center",
            }}
          >
            {t("404.title")}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            {t("404.description")}
          </Typography>
        </Box>
        <Box
          component="img"
          sx={{
            height: 260,
            my: { xs: 5, sm: 10 },
          }}
          alt="404"
          src={"/assets/illustrations/warning.svg"}
        />

        <Button to="/" component={RouterLink} size="large" variant="contained" color="inherit">
          {t("404.button")}
        </Button>
      </Stack>
    </Stack>
  )
}

export default NotFound
